/**
 * Debug Logger Utility
 * Simple logging utility for development and debugging.
 * 
 * All variable names, logs, and comments are in English.
 */

interface LogData {
  [key: string]: any;
}

class DebugLogger {
  private isDevelopment: boolean;

  constructor() {
    this.isDevelopment = process.env.NODE_ENV === 'development';
  }

  /**
   * Log general information
   */
  log(message: string, data?: LogData): void {
    if (this.isDevelopment) {
      if (data) {
        // Debug logging disabled in production
      } else {
        // Debug logging disabled in production
      }
    }
    // No-op in production
  }

  /**
   * Log error information
   */
  error(message: string, data?: LogData): void {
    if (this.isDevelopment) {
      if (data) {
        console.error(`[ERROR] ${message}`, data);
      } else {
        console.error(`[ERROR] ${message}`);
      }
    }
    // No-op in production
  }

  /**
   * Log warning information
   */
  warn(message: string, data?: LogData): void {
    if (this.isDevelopment) {
      if (data) {
        console.warn(`[WARN] ${message}`, data);
      } else {
        console.warn(`[WARN] ${message}`);
      }
    }
  }

  /**
   * Log info information
   */
  info(message: string, data?: LogData): void {
    if (this.isDevelopment) {
      if (data) {
        console.info(`[INFO] ${message}`, data);
      } else {
        console.info(`[INFO] ${message}`);
      }
    }
  }
}

export const debugLogger = new DebugLogger();
export default debugLogger;
